import React from 'react';
import Button from '@nexus/fff-ui-shared/Button';
import styles from './NotifyMeButton.module.scss';

const NotifyMeButton = () => (
  <div className={styles.container} data-testid="notify-me">
    <a className={styles.wrapperButton} href="#outofstock_email_signup">
      <Button>NOTIFY ME</Button>
    </a>
    <div className={styles.copy}>
      Enter your email to be notified when back in stock
    </div>
  </div>
);

export default NotifyMeButton;
